import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener("turbo:submit-start", this.handleSubmitStart)
    this.element.addEventListener("turbo:submit-end", this.handleSubmitEnd)
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-start", this.handleSubmitStart)
    this.element.removeEventListener("turbo:submit-end", this.handleSubmitEnd)
  }

  handleSubmitStart = (e) => {
    const submitter = e.detail.formSubmission.submitter
    if (!submitter) return

    this.#setLoadingState(submitter)
  }

  handleSubmitEnd = (e) => {
    const submitter = e.detail.formSubmission.submitter
    if (!submitter) return

    if (e.detail.fetchResponse.response.redirected === true) {
      this.#setLoadingState(submitter)
    } else {
      this.#setNormalState(submitter)
    }
  }

  #buildLoadingContent(button) {
    return [this.#submitIcon(), button.textContent.trim()].join("")
  }

  #setLoadingState(button) {
    button.dataset.originalContent = button.innerHTML
    button.disabled = true
    button.innerHTML = this.#buildLoadingContent(button)
  }

  #setNormalState(button) {
    button.disabled = false
    if (button.dataset.originalContent) {
      button.innerHTML = button.dataset.originalContent
    }
  }

  #submitIcon() {
    return `<svg id="arrow-path" class="inline-block size-4 animate-spin" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path fill-rule="evenodd" d="M4.755 10.059a7.5 7.5 0 0112.548-3.364l1.903 1.903h-3.183a.75.75 0 100 1.5h4.992a.75.75 0 00.75-.75V4.356a.75.75 0 00-1.5 0v3.18l-1.9-1.9A9 9 0 003.306 9.67a.75.75 0 101.45.388zm15.408 3.352a.75.75 0 00-.919.53 7.5 7.5 0 01-12.548 3.364l-1.902-1.903h3.183a.75.75 0 000-1.5H2.984a.75.75 0 00-.75.75v4.992a.75.75 0 001.5 0v-3.18l1.9 1.9a9 9 0 0015.059-4.035.75.75 0 00-.53-.918z" clip-rule="evenodd"/>
      </svg>`
  }
}
